// resizeHelper.js (CommonJS)

module.exports = {
  onMouseDown (e, component) {
    if (component.boundMove) document.removeEventListener('mousemove', component.boundMove)
    if (component.boundUp) document.removeEventListener('mouseup', component.boundUp)
    component.startX = e.clientX
    component.startWidth = component.$refs.left.offsetWidth
    component.$refs.left.parentElement.style.userSelect = 'none'

    // Bind "this" correctly by using component reference
    component.boundMove = (evt) => module.exports.onMouseMove(evt, component)
    component.boundUp = () => module.exports.onMouseUp(component)

    document.addEventListener('mousemove', component.boundMove)
    document.addEventListener('mouseup', component.boundUp)
  },

  onMouseMove (e, component) {
    const deltaX = e.clientX - component.startX
    component.$refs.left.style.width = `${component.startWidth + deltaX}px`
  },

  onMouseUp (component) {
    document.removeEventListener('mousemove', component.boundMove)
    document.removeEventListener('mouseup', component.boundUp)
    component.$refs.left.parentElement.style.userSelect = 'none'
  }
}
